import { render, staticRenderFns } from "./yujingzhishezhi.vue?vue&type=template&id=2ec81276&scoped=true&"
import script from "./yujingzhishezhi.vue?vue&type=script&lang=js&"
export * from "./yujingzhishezhi.vue?vue&type=script&lang=js&"
import style0 from "./yujingzhishezhi.vue?vue&type=style&index=0&id=2ec81276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec81276",
  null
  
)

export default component.exports